'use client';

import { useState } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { inputDateFormat } from 'constant';
import { formatHandler } from 'services';

import { Box, Button, Flex, Stack, useTheme } from '@chakra-ui/react';

interface CalendarSearchProps extends Omit<ReactDatePickerProps, 'onChange'> {
  btnText: string;
  withButton?: boolean;
  onChange: (value: string) => void;
  onShowFirstAvailable: () => void;
}

const CalendarSearch = ({
  btnText,
  onChange,
  onShowFirstAvailable,
  withButton = false,
  ...rest
}: CalendarSearchProps) => {
  const [value, setValue] = useState<Date | null>(null);

  const {
    colors: {
      palette: {
        booking: {
          stepTime: { calendarSearch }
        }
      }
    }
  } = useTheme();

  const todayDate = new Date();

  const handleDayPickerChange = (date: Date) => {
    const formattedDate = formatHandler(date, '', inputDateFormat);
    setValue(date);
    onChange(formattedDate);
  };

  return (
    <Stack
      className='full-width'
      gap={{ base: '13px', md: '23px' }}
      w='100%'
      p={{
        base: '20px 30px 25px',
        md: '30px 15px 20px',
        lg: '30px 35px',
        xl: '30px 40px'
      }}
    >
      {withButton && (
        <Flex alignItems='center' justifyContent='center'>
          <Button
            variant='solid'
            w='222px'
            h='45px'
            onClick={onShowFirstAvailable}
            color={calendarSearch.buttonTextColor}
          >
            {btnText || 'Today Day'}
          </Button>
        </Flex>
      )}
      <Box>
        <ReactDatePicker
          inline
          minDate={todayDate}
          selected={value || null}
          dateFormat='MM-dd-yyyy'
          onChange={handleDayPickerChange}
          fixedHeight
          {...rest}
        />
      </Box>
    </Stack>
  );
};

export default CalendarSearch;
